<template>
  <v-radio-group
    v-model="local.watchProps.labelTypeId"
    :mandatory="true"
    hide-details
  >
    <div>
      <v-sheet
        max-width="800"
        class="pa-4"
        style="border: 1px solid #ddd; margin-bottom: 20px;"
      >
        <!-- <v-radio
          v-for="label in labelType.examples"
          :key="label.labelTypeId"
          :value="label.labelTypeId"
          :label="label.labelText"
          class="box-divider align-start"
        >
          <template v-slot:label>
            <span v-html="label.labelText" />
          </template>
        </v-radio> -->
        <v-radio
          v-for="labelType in labelTypes"
          :key="labelType.labelTypeId"
          :value="labelType.labelTypeId"
          :label="labelType.examples[0].labelText"
          class="box-divider align-start"
        >
          <template v-slot:label>
            <span v-html="labelType.examples[0].labelText" />
          </template>
        </v-radio>
      </v-sheet>
    </div>
  </v-radio-group>
</template>

<script>

import { OUTBOX_ENTITY_SOURCE_TYPE } from '@/constant/constant'
import outboxApi from '@/api/outbox/outbox'

function getAddressExamples (inst, entitySourceTypeId) {
  outboxApi.getAddressExamples(entitySourceTypeId, resp => {
    if (resp.status === 201 || resp.status === 200) {
      inst.labelTypes = [...inst.labelTypes, ...resp.data]
    }
  })
}

export default {
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  data: () => {
    return {
      labelTypes: []
    }
  },
  computed: {
    local () {
      return this.value ? this.value : {
        watchProps: {
          labelTypeId: null
        }
      }
    }
  },
  created () {
    getAddressExamples(this, OUTBOX_ENTITY_SOURCE_TYPE.APM)
    // getAddressExamples(this, OUTBOX_ENTITY_SOURCE_TYPE.ATFM)
  }
}
</script>
